export default __webpack_public_path__ + "static/fb-fc912bfeb1c696f74f753d188e4866c7.jpg";